module.exports = __webpack_public_path__ + "img/c[Arg(Pbf)-Gly-Asp(OtBu)-DPhe-Lys].241f1878.png";